import {AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";
import {useUserStore} from "@/app/stores/user-store.ts";
import type {SelectOption} from "@/app/shared/helpers/enum.ts";
import {getActivePinia} from "pinia";

export const getAvailableServices = <AthumiService>(excludeValues: string[] = []): SelectOption<AthumiService[keyof AthumiService]>[] => {
    const activePinia = getActivePinia();
    const availableServices = activePinia
        ? useUserStore(activePinia).services.map(s => s.service.toUpperCase())
        : undefined;
    const excludedServices = excludeValues.map(s => s.toUpperCase());
    const entries = Object.entries(AthumiService);
    const nonNumericKeyEntries = entries.filter(([key]) => isNaN(Number(key)));

    return nonNumericKeyEntries
        .filter(([key]) => {
            const normalizedKey = key.toUpperCase();
            if (excludedServices.includes(normalizedKey)) {
                return false;
            }

            if (!availableServices) {
                return key !== 'All';
            }

            return availableServices.includes(normalizedKey) || key === 'All';
        })
        .map(([key, value]) => ({
            label: key === 'All' || key === 'None' ? ' ' : key.toUpperCase(),
            value: value as AthumiService[keyof AthumiService]
        }));
}